/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'copy': {
    width: 19,
    height: 18,
    viewBox: '0 0 19 18',
    data: '<path pid="0" _fill="#FFF" d="M16.783 0a2 2 0 0 1 2 2v8.522a2 2 0 0 1-2 2l-4.262-.001v3.403a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7.402a2 2 0 0 1 2-2h4.26V2a2 2 0 0 1 2-2h8.523zM6.26 6.602H2l-.1.006a.8.8 0 0 0-.7.794v8.522a.8.8 0 0 0 .8.8h8.522a.8.8 0 0 0 .8-.8l-.001-3.403h-3.06a2 2 0 0 1-2-2L6.26 6.603zm4.262 0H7.46v3.92a.8.8 0 0 0 .8.8l3.061-.001V7.402a.8.8 0 0 0-.8-.8zm6.26-5.402h-8.52a.8.8 0 0 0-.8.8L7.46 5.402h3.062a2 2 0 0 1 2 2l-.001 3.919h4.262a.8.8 0 0 0 .8-.8V2a.8.8 0 0 0-.8-.8z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/copy.js